/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type asset = {
    /**
     * Hex-encoded asset full name
     */
    asset: string;
    /**
     * Policy ID of the asset
     */
    policy_id: string;
    /**
     * Hex-encoded asset name of the asset
     */
    asset_name: string | null;
    /**
     * CIP14 based user-facing fingerprint
     */
    fingerprint: string;
    /**
     * Current asset quantity
     */
    quantity: string;
    /**
     * ID of the initial minting transaction
     */
    initial_mint_tx_hash: string;
    /**
     * Count of mint and burn transactions
     */
    mint_or_burn_count: number;
    /**
     * On-chain metadata which SHOULD adhere to the valid standards,
 * based on which we perform the look up and display the asset
 * (best effort)
 * 
     */
    onchain_metadata: any | null;
    /**
     * If on-chain metadata passes validation, we display the standard
 * under which it is valid
 * 
     */
    onchain_metadata_standard?: asset.onchain_metadata_standard;
    /**
     * Off-chain metadata fetched from GitHub based on network.
 * Mainnet: https://github.com/cardano-foundation/cardano-token-registry/
 * Testnet: https://github.com/input-output-hk/metadata-registry-testnet/
 * 
     */
    metadata: any | null;
};

export namespace asset {

    /**
     * If on-chain metadata passes validation, we display the standard
 * under which it is valid
 * 
     */
    export enum onchain_metadata_standard {
        CIP25V1 = 'CIP25v1',
        CIP25V2 = 'CIP25v2',
        CIP68V1 = 'CIP68v1',
    }


}
